import React from 'react';
import { makeStyles } from '@material-ui/styles';
import MessageIcon from '@material-ui/icons/Message';
import { useDispatch } from 'react-redux';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

import Page from './PageV2';
import MessagesList from '../containers/Messages/MessagesList';
import AutoResponse from '../containers/Messages/AutoResponse';
import BroadcastMessage from '../containers/Messages/BroadcastMessage';

import PageCards from '../components/PageCards';
import { setDialog } from '../lib/store/reducers/dialog';
import { DIALOG_TYPES } from '../lib/constants/dialog-types';

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
  deleteIcon: {
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
    color: theme.palette.error.main,
  },
}));

function MessagesPage() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const broadcastMenuItem = [
    {
      title: (
        <>
          <AddIcon className={classes.icon} /> Add New Broadcast
        </>
      ),
      onClick: () =>
        dispatch(
          setDialog({ open: true, dialog: DIALOG_TYPES.ADD_NEW_BROADCAST }),
        ),
    },
  ];

  const automatedMessageMenuItem = [
    {
      title: (
        <>
          <EditIcon className={classes.icon} /> Add / Update
        </>
      ),
      onClick: () =>
        dispatch(
          setDialog({
            open: true,
            dialog: DIALOG_TYPES.ADD_OR_UPDATE_AUTOMATED_MESSAGE,
          }),
        ),
    },
  ];

  const cards = [
    {
      id: 'broadcast', //TODO:Get the correct icon for broadcast (https://v4.mui.com/components/material-icons/ doesn't have it)
      title: (
        <>
          <MessageIcon className={classes.icon} /> Broadcast Message
        </>
      ),
      gridContainerProps: {
        spacing: 3,
        direction: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        style: { marginBottom: '2rem' },
      },

      menuItems: broadcastMenuItem,
      Element: <BroadcastMessage />,
    },
    {
      id: 'messages',
      title: (
        <>
          <MessageIcon className={classes.icon} /> Messages
        </>
      ),
      gridContainerProps: {
        spacing: 3,
        direction: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      subCards: [
        {
          id: 'auto-generated',
          title: 'Automated Message',
          menuItems: automatedMessageMenuItem,
          Element: <AutoResponse />,
          paperElevation: 0,
        },
        {
          id: 'messages',
          title: 'Messages',
          Element: <MessagesList />,
          paperElevation: 0,
        },
      ],
    },
  ];

  return (
    <>
      <Page
        paperElevation={0}
        gridContainerProps={{
          spacing: 3,
          direction: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        gridItemProps={{ xs: 12, lg: 8 }}>
        <PageCards cards={cards} />
      </Page>
    </>
  );
}

export default MessagesPage;
